import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdatePriceSchemeRequestBody, IUpdatedPriceScheme } from './types';

export const updatePriceScheme = async (
  priceSchemeId: string,
  requestBody: IUpdatePriceSchemeRequestBody,
): Promise<IUpdatedPriceScheme> => {
  const response = await fetch(`${API_URL}/pricing/schemes/${priceSchemeId}`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // A gateway failure can return HTML rather than JSON, so the body may not parse at all.
  const json = await response.json().catch(() => null);

  if (response.status === Status.SUCCESS && json?.data?.[0]) return json.data[0];

  const message = typeof json?.message === 'string' ? json.message : 'Failed to rename price scheme';
  throw new Error(message);
};
